import { gql } from '@urql/core';

const QueryCourierToken = gql`
  query CourierToken {
    courierToken
  }
`;

export default QueryCourierToken;
